var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_329_605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00091 0C3.14114 0 0.000976562 3.14016 0.000976562 6.99993C0.000976562 10.8598 3.14114 14.0001 7.00091 14.0001C7.28974 14.0001 7.52378 13.766 7.52378 13.4772C7.52378 13.1884 7.28974 12.9543 7.00091 12.9543C3.71776 12.9543 1.04672 10.2832 1.04672 6.99993C1.04672 3.71678 3.71776 1.04574 7.00091 1.04574C10.2841 1.04574 12.9551 3.71678 12.9551 6.99993V8.61944C12.9551 9.22402 12.4632 9.71587 11.8585 9.71587C11.2539 9.71587 10.7621 9.22402 10.7621 8.61944V6.99993C10.7621 4.92587 9.07483 3.23853 7.00084 3.23853C4.92678 3.23853 3.23944 4.92587 3.23944 6.99993C3.23944 9.07413 4.92678 10.7616 7.00084 10.7616C8.15192 10.7616 9.18331 10.2413 9.87377 9.4241C10.1925 10.2076 10.9618 10.7616 11.8585 10.7616C13.0397 10.7616 14.0008 9.80064 14.0008 8.61944V6.99993C14.0008 3.14016 10.8607 0 7.00091 0ZM7.00091 9.71587C5.50347 9.71587 4.28525 8.49751 4.28525 6.99993C4.28525 5.5025 5.50354 4.28427 7.00091 4.28427C8.49827 4.28427 9.71643 5.5025 9.71643 6.99993C9.71643 8.49751 8.49827 9.71587 7.00091 9.71587Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_329_605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/dog.61a7a0107f46f831059f3ceebffdb144.svg";
export { ForwardRef as ReactComponent };